import React from 'react';
import type { Control, FieldValues, Path } from 'react-hook-form';

import TextField from './TextField';

type Props<T extends FieldValues> = {
  control: Control<T>;
  name: Path<T>;
  label: string;
  required?: boolean;
};

const EmailField = <T extends FieldValues>(props: Props<T>) => (
  <TextField {...props} type="email" placeholder={props.label} />
);

export default EmailField;
